import React from 'react';
import { IdServiceApp } from './modules/IdSeviceApp/IdServiceApp';

export interface AuthAction {
  label: string;
  action: () => void;
}

const App: React.FC = () => {
  return <IdServiceApp />;
};

export default App;
